<template lang='pug'>
.fp-spinner(:style='{ height: getHeight }')
  img(src='~@/assets/spinner.svg')
</template>
<script>
export default {
  data () {
    return {
      defaultHeight: '20px'
    }
  },
  props: {
    height: String
  },
  computed: {
    getHeight () {
      if (this.height) return this.height
      return this.defaultHeight
    }
  },
  mounted () {
    if (this.$el && this.$el.parentElement) {
      this.defaultHeight = `${this.$el.parentElement.offsetHeight}px`
    }
  }
}
</script>

<style lang="less">
.fp-spinner {
  padding: 6px 12px;
  height: inherit;
  position: relative;
  display: inline-block;
  width: 34px;
  img {
    position: absolute;
    top: 50%;
    width: 20px;
    transform:translate(-50%, -25%);
    left: 50%;
  }
}
</style>

